import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
// import {SlideDown} from 'react-slidedown'
import {
  AboutBanner,
  Works,
  Link,
  LinkIcon,
  GetStartedInput,
  ScreenedCompanies,
  Grade,
  Changelog
} from '../../components'
import ReactTooltip from 'react-tooltip'
import Styles from './HowItWorks.css'

@CSSModules(Styles)
export default class HowItWorks extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  renderHowItWorksContent = () => {
    const sriIcon = require( '../../../static/images/sri.png' )
    const ussifIcon = require( '../../../static/images/ussif-logo.png' )
    // const cleanChartImg = require( '../../../static/images/clean-chart.png' )
    const dirtyChartImg = require( '../../../static/images/dirty-chart.png' )
    const categorySwitchesImg = require( '../../../static/images/category-switches.png' )
    const categoryChartImg = require( '../../../static/images/category-chart.png' )

    // const iconMmc = require( '../../../static/images/icn-mmc.svg' )
    // const iconCm = require( '../../../static/images/icn-cm.svg' )
    // const iconNw = require( '../../../static/images/icn-nw.svg' )
    // const iconGm = require( '../../../static/images/icn-gm.svg' )
    // const iconGr = require( '../../../static/images/icn-gr.svg' )

    return (
      <div styleName='how-it-works'>
        <div styleName='how-it-works-inner'>
          <div styleName='answer-title'>
            Mutual funds
          </div>
          <div styleName='answer-info'>
            <p>
              Mutual funds are baskets of stocks bundled together, sometimes hundreds or thousands of companies. They are some of the most popular investment products for retirement plans, because owning so many company stocks at once helps diversify investment risk. But unless you're a financial professional, it can be difficult to find out just what companies are inside the funds you're invested in. That's where we come in. We examine every holding in thousands of funds to determine if there are investments in gun stocks.
            </p>
          </div>
          <div styleName='answer-title'>
            Sustainable investing
          </div>
          <div styleName='answer-info'>
            <p>
              Some funds actively choose to invest responsibly, by considering environmental or social issues when choosing companies to invest in. If you're thinking about weapon free investing, socially responsible funds can be a good place to start, because they often deliberately avoid companies that make civilian firearms. We feature nearly a hundred socially responsible funds in our database.
            </p>
          </div>

          <div styleName='answer-title'>
            Sustainable investing can offer competitive returns
          </div>
          <div styleName='answer-info'>
            <p>
              While people may become interested in responsible investing because of personal values and goals, that doesn't mean they're not looking for a competitive financial return on their investments. Fortunately, the evidence is clear: sustainable and responsible investors do not have to pay more to align their investments with their values, or to avoid companies with poor environmental, social or governance practices. <Link to={config.links.ussifperf} title='Performance and SRI' xstrong={true}>The Forum for Sustainable and Responsible Investment</Link> has collected the research.
            </p>
          </div>
          <div styleName='answer-title'>
            Finding a fund
          </div>
          <div styleName='answer-info'>
            <p><strong>Gun Free Funds</strong> sources financial data on equities and mutual funds from SEC's Edgar database. Our tool contains information on thousands of U.S. open-end and exchange traded mutual funds, some of the most common funds held in 401(k)s, 403(b)s, and other retirement plans.</p>
            <p>Search for mutual funds using name, ticker symbol, or asset manager. <Link to={config.routes.clean} xstrong={true} title='Search funds'>Use the search page</Link> to filter funds by investing style, fund family, and more. When you find a fund you're looking for, click on it to see the full results.</p>

            <p>We don't have everything in our database &mdash; we only screen mutual funds that own direct stock investments, and can only display up to 3,000. Looking for your favorite fund and can&rsquo;t find it? With more resources, we could include more funds &mdash; <Link xstrong={true} to={config.links.donate} title='Donate to As You Sow'>make a gift today to make a difference.</Link></p>
          </div>
          <div styleName='answer-title'>
            Screening a fund
          </div>
          <div styleName='answer-info'>
            <p>For each mutual fund in our database, we examine every holding and determine if it is a stock issued by a gun manufacturer or a gun retailer.</p>
            <p>We only look for direct stock holdings in gun companies. That means that holdings that are not stocks, like corporate bonds, are not analyzed. In the fund's investment profile, we show a "Percent Rated" metric, equivalent to the percent of the fund that is invested in stocks. The higher a fund&rsquo;s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden gun-related investments that our tool cannot account for, in the form of bond holdings or other asset types.</p>
          </div>
          <div styleName='sidebar'>
            <div styleName='sidebar-title'>
              <LinkIcon faclass='fa-info-circle' nospace/>
              &nbsp;
              <em>Measuring long holdings only</em>
            </div>
            <div styleName='sidebar-info'>
              <p>
                When calculating a fund's exposure to a screen list, we only consider the portfolio's long investments, ignoring any shorts or liabilities. The formula for holding weight is <em>holding market value divided by the sum of the market value for all long holdings in the portfolio.</em>
              </p>
            </div>
          </div>
          <div styleName='answer-title'>
            If a fund holds stock in a gun company
          </div>
          <div styleName='answer-info'>
            <p>We use two different gun company categories, grouped into two screens.</p>

            <ScreenedCompanies />

          </div>
          <div styleName='answer-title'>
            We calculate the fund's gun grade
          </div>
          <div styleName='answer-info'>
            <p>Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. We calculate the total number of flagged holdings in the fund, and the total amount and percentage of the fund’s assets that are invested in those companies.</p>

            <p>Based on what companies a fund owns, it is assigned one of five civilian firearm grades.</p>

            <div styleName='risk-bullet'>
              <Grade grade={1} large/>
              <p styleName='screen-icon-label'>
                No holdings flagged for our civilian firearm screens. Assigned a grade of A.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={2} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in civilian firearm retailers, but no holdings flagged for our civilian firearm manufacturers screen. Assigned a grade of B.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={3} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in civilian firearm manufacturers, below the threshold of 0.1%. Assigned a grade of C.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={4} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in civilian firearm manufacturers, above the threshold of 0.1% and below 0.4%. Assigned a grade of D.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={5} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in civilian firearm manufacturers, above the threshold of 0.4%. Assigned a grade of F.
              </p>
            </div>
            <p>
              These thresholds reflect the distribution of results across
              funds, placing an approximately equal number of funds from the
              analysis universe in the C, D, and F grade ranges.
            </p>
            <p>If a fund has direct stock investments in gun manufacturers or major gun retailers, you'll see a chart like this, showing the overall exposure.</p>

            <img
              styleName='dirty-chart-img'
              src={dirtyChartImg}
              alt='Chart for fund that owns stock in gun companies'
            />

            <p>Next to the chart, you'll see the exposure breakdown for each of the gun categories.</p>

            <img
              styleName='category-switches-img'
              src={categorySwitchesImg}
              alt='Breakdown of gun exposure for each of the gun categories'
            />

            <p>If you click a category that a fund has exposure to, you'll see the breakdown of the individual companies in that category that the fund owns.</p>

            <img
              styleName='category-chart-img'
              src={categoryChartImg}
              alt='Chart for a single gun category'
            />

          </div>
          <div styleName='answer-title'>
            We track sustainable funds
          </div>
          <div styleName='answer-info'>
            <p>We apply a "sustainability mandate" indicator to indicate which funds are categorized as sustainable investments. Funds with sustainability mandates often make investment decisions based on issues like environmental responsibility, human rights, or religious views. A socially responsible fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are designated socially responsible.</p>

            <img
              styleName='sri'
              src={sriIcon}
              alt='Socially responsible fund'
              data-multiline={true}
              data-effect={'solid'}
              data-html={true}
              data-for='sri-icons-tooltip'
              data-place='bottom'
              data-tip="<div style='max-width:200px;'>Designated a sustainable investment. Sustainable funds consider issues like the environment and human rights.</div>"
            />

            <p>The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of civilian firearms. Look for this symbol to find funds that are members of US-SIF.</p>

            <img
              styleName='ussif'
              src={ussifIcon}
              alt='Member of US-SIF, the Forum for Sustainable and Responsible Investment'
              data-multiline={true}
              data-effect={'solid'}
              data-html={true}
              data-for='sri-icons-tooltip'
              data-place='bottom'
              data-tip="<div style='max-width:200px;'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>"
            />

            <ReactTooltip id='sri-icons-tooltip'/>

          </div>

          <div styleName='answer-title'>
            Gun free action toolkit
          </div>

          <div styleName='answer-info'>
            <p>When you're done looking up funds and finding the data you need, what's next? You can learn how to make a change and move your money with our <Link to={config.routes.toolkit} xstrong={true} title='Gun free action toolkit'>gun free action toolkit</Link>. Whether you’re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There's an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more &mdash; everything you need to make a change and get started investing your money gun free.</p>
          </div>

        </div>
      </div>
    )
  }

  render() {
    const title = 'How it works'
    const description = 'Get your money out of guns. Gun Free Funds tracks thousands of mutual funds commonly found in retirement plans.'
    const url = config.domain + config.routes.howitworks

    const bannerImage = 'green'
    const bannerHeadline = 'How it works'
    const bannerSubtitle = 'Getting started with Gun Free Funds'

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>{bannerHeadline}</div>
                <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
              </div>
            </div>
          </div>
        </div>

         <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
               <div styleName='title'>
                Methodology and companies we screen for
               </div>
               <div styleName='lede'>
                 Gun Free Funds sources financial data from SEC's Edgar database to analyze mutual funds and track investments in civilian firearms. Our database covers thousands of the most popular funds, the type of investments most common in retirement plans like employer-offered 401(k)s.
               </div>

              <Changelog />
               
             </div>
           </div>
         </div>

        <Works/>

        {this.renderHowItWorksContent()}

        <GetStartedInput />

        <div styleName='ab-container'>
          <div styleName='ab-container-inner'>
            <AboutBanner />
          </div>
        </div>

      </div>
    )
  }
}
